export const buttonHeight = '56px';

export const buttonWidth = '56px';
